import * as React from 'react'
import ProgressBar from "./ProgressBar"
import PlayButton from '../../../DVWebNodeStorefront/shared/components/collection/FacetedCarousel/Card/Packshot/PlayButton'
import fireDraperTrackingEvent from '../../../DVWebNodeStorefront/shared/utils/draper'
import * as styles from './PlaybackBlock.module.scss'
import { StorefrontItemPlaybackAction, ItemPrerolls } from '@utils'
import { Text } from 'DVWebNodeUI'

export interface CommonPlaybackAction extends StorefrontItemPlaybackAction {
    progress?: number
    prerolls?: ItemPrerolls
}

const PlaybackWrapper = ({ playbackAction, children }: { playbackAction: CommonPlaybackAction, children: React.ReactChild | React.ReactChild[] }) => (
    <a
        className={'js-deeplinkable'}
        data-asin={playbackAction && playbackAction.titleID}
        data-ref-tag={playbackAction && playbackAction.refMarker}
        data-ref={playbackAction && playbackAction.refMarker}
        data-resume-time={playbackAction &&
            (playbackAction.resumeTime || '0')}
        href={playbackAction.fallbackUrl}
        data-video-type={playbackAction &&
            playbackAction.videoMaterialType}
        data-session-id={playbackAction && playbackAction.sessionID}
        data-fallback-url={playbackAction && playbackAction.appFallbackUrl}
        onClick={() => { if (playbackAction.prerolls) { fireDraperTrackingEvent(playbackAction.prerolls, 'acceptInvitation')}}}>
        {children}
    </a>
)

export const PlaybackBlock = ({ playbackAction }: { playbackAction: CommonPlaybackAction }) => (
    <>
        <PlaybackWrapper playbackAction={playbackAction}>
            <PlayButton wrapperStyle={styles.playButton}
                circleStyle={styles.circle}
                triangleStyle={styles.triangle}
                svgStyle={styles.svg} />
        </PlaybackWrapper>
        <div className={styles.playbackAction}>
                <Text className={styles.playbackLabel}>{playbackAction.label}</Text>
            <ProgressBar progress={playbackAction.progress} />
        </div>
    </>
)
